import { Container, Image, Select, Grid } from "semantic-ui-react"
import logo from "../../assets/logo.png"
import signature from "../../assets/signature.png"
import footer from "../../assets/footerLetterNew.png"
import { useSelector, useDispatch } from "react-redux"
import { setLetterJsOfficer, setLetterSubsidyContractDate, setSelectedDate } from "../../redux/projectSlice"
import DatePicker from "react-datepicker"
import "react-datepicker/dist/react-datepicker.css"
import dateFormat from "dateformat";
import '../../cssASupp/NotificationLetter.css'


const SubsidyContractCoverLetter = () => {
    const dispatch = useDispatch();
    const projectState = useSelector(state => state.project);
    const handleSelectChange = (e, data) => {
        dispatch(setLetterJsOfficer(data.value));
    }

    const handleDateChange = (date) => {
        dispatch(setSelectedDate(date.getTime()));
        const dateTxt = dateFormat(date, "d mmmm yyyy")
        dispatch(setLetterSubsidyContractDate(dateTxt));
    }

    const getDateFromState = () => {
        const timestamp = projectState.letter?.subsidyContractDate
        //console.warn('timestamp', timestamp)
        let date
        if (timestamp) {
            date = new Date(timestamp)
        } else {
            date = new Date()
            const dateTxt = dateFormat(date, "d mmmm yyyy")
            dispatch(setLetterSubsidyContractDate(dateTxt));
        }
        return date
    }

    const renderHeaderDestination = () => {
        const lp = projectState.leadPartner
        const contact = lp.contacts.filter(contact => contact.type === 'ContactPerson')[0]
        return (
            
            // <div className="espace-haut-20">
            <div>
            <Grid>
                <Grid.Row >
                    <Grid.Column width={10}>
                    </Grid.Column>
                    <Grid.Column width={6}>
                        <Container textAlign='left'>
                            <p >
                            <span className="text-accent">{contact.title} {contact.firstName} {contact.lastName}<br /></span>
                                {lp.nameInEnglish}<br />
                                {lp.addresses[0].street} {lp.addresses[0].houseNumber}<br />
                                {lp.addresses[0].postalCode} {lp.addresses[0].city}<br />
                                {lp.addresses[0].country}<br />
                            </p>
                            <div className="espace-haut">
                            {/* <span className="text-accent">Lille, {projectState.letter?.subsidyContractDate ? projectState.letter?.subsidyContractDate : <span className="error-accent">Please select a date</span>} <DatePicker dateFormat="dd/MM/yyyy" selected={getDateFromState()} onChange={(date) => handleDateChange(date)} className="notification-letter-logo invisible-print" /></span> */}
                            <span className="text-accent">Lille, {projectState.letter?.subsidyContractDate} <DatePicker dateFormat="dd/MM/yyyy" selected={getDateFromState()} onChange={(date) => handleDateChange(date)} className="notification-letter-logo invisible-print" /></span>
                            </div>
                        </Container>
                    </Grid.Column>
                </Grid.Row>
            </Grid>
            </div>
        )
    }

    const renderLetter = () => {
        const letter = projectState.letter
        const project = projectState.project
        const lp = projectState.leadPartner
        const contact = lp.contacts.filter(contact => contact.type === 'ContactPerson')[0]
        const title = project.title.filter(title => title.language === 'EN')[0].translation
        const selectedJsOfficer = projectState.jsOfficers.filter(jsOfficer => jsOfficer.value === letter?.jsOfficer)

        return (
            <Container textAlign='justified' className="espace-haut">
                <p>Dear {contact.title} {contact.lastName},</p>
                <p>Congratulations! Your application <span className="text-accent">{project.customIdentifier} {title} ({project.acronym})</span> has met the technical requirements set by the NWE Monitoring Committee on {letter?.commission?.step2Date}, in {letter?.commission?.step2Location}. We kindly ask you to inform your project partners.</p>
                <p>Please find enclosed three copies of your subsidy contract. Annex 1, which is your approved Application Form, can be downloaded in Jems.</p>
                <p>Please date and sign all three copies. You should retain one copy, and return the other two signed copies by post, as soon as possible, to the following address:</p>
                <p className="text-accent">Interreg North-West Europe  <Select placeholder="Select officer" defaultValue={selectedJsOfficer} options={projectState.jsOfficers} className="invisible-print margin-top-bottom-10" onChange={handleSelectChange} /> <br />
                    {letter?.jsOfficer ? <span >{letter?.jsOfficer[0]} </span> : <span className="error-accent">Please select an Officer</span>}<br />
                    45 rue de Tournai, 6/D<br />
                    F-59000 Lille<br />
                    France
                </p>
                <p>Furthermore, we ask you to provide information in the Contracting section, in Jems. To do this, please go to the NWE monitoring system Jems (jems.nweurope.eu), enter your project application and access the Contracting section in the left-side menu.</p>
                <p> - Information about the project management team should be filled under “Project managers”.</p>
                <p >Then, still in the Contracting section, please go to partner details. There are 3 main areas there: “Ultimate Beneficial Owner(s)”, “Bank details” and “Location of documents”.</p>
                <p className="espace-haut-70"> - You should fill in the account details and the bank details for the Lead partner. It is necessary to upload, in the attachments area down the page, a document from your bank or on signed letter-headed paper, including the following account details:</p>
                <ul>
                    <li>Account holder</li>
                    <li>Account number</li>
                    <li>IBAN</li>
                    <li>BIC/ Swift code</li>
                    <li>Internal reference number</li>
                    <li>Name of the bank</li>
                    <li>Bank address</li>
                </ul>
                
                <p>There is no obligation to fill in bank details for the rest of the partnership (only the Lead partner is a must), but we highly encourage you to gather this information there. It will ease the transfer of funds to the partners.</p>
                <p> - All partners will eventually need to complete the fields related to the “Location of documents”, at the latest when they wish to submit their first partner reports to their controllers.</p>
                <p> - The fields for the “Ultimate Beneficial Owner(s) will also need to be filled in by then, but this only applies to partners who have declared their legal status to be “private” in section B.1.1 of the Application form.</p>
                <p>The preparation costs will be paid to the project Lead Partner once:</p>
                <ul>
                    <li>the project management section is completed</li>
                    <li>the fields about the lead partner bank account are filled in</li>
                    <li>a valid document substantiates the data about the bank account,</li>
                    <li>the signed subsidy contract has been received.</li>
                </ul>
               
                <p>We remain at your disposal if you have any question.</p>
                <p>Kind regards,</p>
                <Image src={signature} size='small' className="espace-haut-large" />
                <p>David Grzegorzewski <br/>
                Programme Director
                </p>
                <div className="espace-haut-70">Enc.: three copies of the subsidy contract</div>
            </Container>
        )
    }

    return (
        <div className="new-color-font margin-cover-letter">
            <table >
                <thead>
                    <div className="print-margin-top-10mm"></div>
                </thead>
                <tbody>
                    <tr >
                        <td>
                            <Container >
                                <Image src={logo} size='medium' />
                            </Container>
                            <Container textAlign="right">
                                {renderHeaderDestination()}
                            </Container>
                            {renderLetter()}
                        </td>
                    </tr>
                </tbody>
                <tfoot>
                    <tr className="footer">
                        <td>
                            <Image src={footer} />
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <div style={{
                                height: 80,
                            }}>

                            </div>
                        </td>
                    </tr>
                </tfoot>
            </table>
        </div>
    )
}

export default SubsidyContractCoverLetter;
